import React from "react";
import { Link } from "react-router-dom";
import "../styles/auth.css";

const Terms = () => {
  return (
    <div className="terms min-w-screen min-h-screen py-10 md:py-16 bg-pfm-dark">
      <div className="container mx-auto">
        <Link to={"/"}>
          <img width="260" alt="Pocket FM" src="/images/icons/pocketfm-logo.svg" />
        </Link>
        <div className="bg-white rounded-3xl p-10 mt-10">
          <div className="">
            <div className="headingx text-5xl font-bold tracking-wide text-main">Terms and Conditions</div>

            <hr className="my-7" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
